import { request } from './client'

// Auth
export interface User {
  id: number
  email: string
  name: string
  role: string
  is_active: boolean
  company_name?: string | null
}

export interface LoginResponse {
  access_token: string
  token_type: string
  user: User
}

export interface SignupPayload {
  email: string
  name: string
  company_name: string
  password: string
}

export const auth = {
  login: (email: string, password: string) =>
    request<LoginResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),
  signup: (payload: SignupPayload) =>
    request<LoginResponse>('/auth/signup', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
  me: () => request<User>('/auth/me'),
  logout: () => request<{ status: string }>('/auth/logout', { method: 'POST' }),
}
